/** @jsxImportSource @emotion/react */
import React, {useEffect} from 'react'
import { Form, Button, Spinner } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@emotion/react'
import { SelectField } from 'components/common/form'

export const DealsValidationForm = ({ isLoading, onDelete, canChangeInternalValidation, canChangeClientValidation, ...props }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const isDisabled = isLoading || props.isSubmitting || Object.keys(props.touched).length === 0
  const hasError = Object.keys(props.errors).length > 0

  const internalModified = React.useCallback((value) => {
    props.values.InternalValidation.Changed = true
    props.values.InternalValidation.Status = Number(value)
  })

  const clientModified = React.useCallback((value) => {
    props.values.ClientValidation.Changed = true
    props.values.ClientValidation.Status = Number(value)
  })
  const clientValidationOptions = [
    { label: t('execution.dealStatus.1'), value: 1 },
    { label: t('execution.dealStatus.2'), value: 2 },
    { label: t('execution.dealStatus.3'), value: 3},
  ]
  
  return (
    <Form
      onSubmit={props.handleSubmit}
      css={{
        section: {
          display: 'grid',
          gridGap: 10,
          gridTemplateColumns: 'repeat(2, 1fr)',
          paddingTop: theme.spacing,
          paddingBottom: theme.spacing * 2,
        },
        footer: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          '>*': {
            display: 'flex',
            justifyContent: 'flex-end',
            button: { marginLeft: '0.6rem' },
          },
        },
      }}
    >
      <hr />
      <section className="mt-4">
      <SelectField
          label={t('execution.transactionView.internalValid')}
          options={clientValidationOptions}
          name="InternalValidation.Status"
          disabled={!canChangeInternalValidation}
          onChangeCustom={internalModified}
        />
      <SelectField
        label={t('execution.transactionView.clientValid')}
        options={clientValidationOptions}
        name="ClientValidation.Status"
        disabled={!canChangeClientValidation}
        onChangeCustom={clientModified}
      />
      </section>
      <footer>
        <div>
          <Button type="submit" disabled={isDisabled || hasError}>
            {isLoading && <Spinner size="sm" style={{ marginRight: '.6rem' }} />}
            <span>{t('strategy.alertPopover.save')}</span>
          </Button>
        </div>
      </footer>
    </Form>
  )
}
